import { cloneDeep, isEmpty } from "lodash";
import { MessageTypeConstants } from "../../services/bot/Message";
import { getConversationById } from "../../utils/conversationUtils";
import {
  ADD_NEW_CONVERSATION, ARCHIVED_MESSAGES_RECEIVED, CHANGE_SELECTED_CONVERSATION, CLEAR_BOTCALL_CONTENT, CLEAR_CHATWIDGET_NOTIFICATIONS, CLEAR_PRINT_SCREEN_CHECK,
  CLEAR_SELECTED_CONVERSATION,
  CLEAR_URL_CONTENT, CLEAR_TIME_LINE, GET_FAVOURITES,
  HIDE_CHATWIDGET_NOTIFICATION,
  NEW_SERVER_MESSAGE_RECEIVED, REMOVE_AUTHORIZATION_REQUEST, REMOVE_NOTIFICATION, REMOVE_TABLE_MESSAGE, RENDER_NOTIFICATION, RESET_CHAT_REDUCER, SELECTED_CONTACT_DATA,
  SELECTED_GROUP_CHAT, SELECTED_GROUP_CHAT_PARTICIPANTS, SET_CHAT_IN_WINDOW, SET_IMESSAGE_CHAT_ACTIVE_AREA, SET_IMESSAGE_CHAT_ACTIVE_AREA_DEATAIL, SET_INITIALIZE_CHAT_IN_WINDOW,
  SET_ONE_TO_ONE_CHAT, SHOW_NOTIFICATION_POP_UP, STANDDARD_NOTI_MSG, TIME_LINE_RECEIVED, TOGGLE__FAVORITE_CONVERSATION, UPDATE_CHATWIDGET_NOTIFICATIONS,
  UPDATE_TIME_LINE
} from "../constants";
import {
  placeMessageBasedOnTime, REPLACEMENT_ENABLED_FOR, shouldReplaceMessageByType,
  updateConversationMetaData
} from "../../services/bot/InteractionsService";
import { IM_BOT } from "../../utils/constants";
import { currentTimeStamp } from "../../utils/moment";
import { mergeAndSortMessages, updatePagination } from "../../utils/Helpers";
import { sortByModifiedOn } from "../actions/chats";

const initialContentState = {
  contentMessage: null,
  smartReplyMessage: null,
  disableMessageInput: false,
  mainChatHeight: "calc(100vh - 71px - 90px)",
};

const initialState = {
  ...initialContentState,
  timeLine: [],
  chatLog: new Map(),
  contacts: [],
  menuMessage: null,
  showWaitSpinner: false,
  conversationModeMap: {},
  selectedConversation: null,
  messageType: null,
  acceptIgnoreContact: null,
  selectedContactData: null,
  conversationPaginationParameterMap: {},
  shouldScrollToTopConversationMap: {},
  showHTMLContent: null,
  urlContent: null,
  ringAction: false,
  deleteModalAction: null,
  modalShow: false,
  chatwidgetNotifications: [],
  oneToOneChat: false,
  selectedGroupChat: null,
  selectedGroupChatParticipants: [],
  chatInWindowOpen: false,
  chatInWindowData: null,
  initializechatInWindow: false,
  embedded: null,
  botCallData: null,
  activeMessageChatArea: false,
  activeMessageChatAreaDetail: null,
  clearedAcceptIgnoreContact: false,
  standardNotiMsg: null,
  notificationsMsgArray: [],
  showNotificationPopUp: false,
  currentRenderedTab: null
};

const chatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_SERVER_MESSAGE_RECEIVED: {
      const { message, conversationId } = action.data;
      const { messageType } = message;
      console.log(`%c Message received from bot to webapp >> ${messageType} >>`, "color: green;", action, currentTimeStamp());

      let chatLog = state.chatLog;
      let timeLine = state.timeLine;
      let messages = chatLog.get(conversationId) || [];

      let conversationModeMapUpdated = state.conversationModeMap;
      let conversationalMode = conversationModeMapUpdated[conversationId];

      if(messageType){
        return {
                ...state,
                currentRenderedTab: action.data
            };
      }

      if (messageType === MessageTypeConstants.MESSAGE_TYPE_MENU) {
        return {
          ...state,
          menuMessage: { ...message.message },
          messageType: messageType
        }
      }
      else if (messageType === MessageTypeConstants.MESSAGE_TYPE_MAP) {
        return {
          ...state,
          conversationModeMap: message,
          messageType: messageType
        };
      }
      else if (messageType === MessageTypeConstants.MESSAGE_TYPE_TABLE) {
        let newDataState = {
          ...state,
          tableMessage: { ...message },
        };

        return newDataState;

      }
      else if (messageType === MessageTypeConstants.MESSAGE_TYPE_DATA) {
        return state;
      }
      else if (messageType === MessageTypeConstants.MESSAGE_TYPE_VIDEO_CALL) {
        const { action } = message.message;
        if (action === 'joinMeeting') {
          return {
            ...state,
            botCallData: message.message,
            ringAction: action,
          };
        }

        const ringAction =
          action === 'ringStart' ? 'ringStart' :
            (action === 'ringStop' || action === 'joinMeeting') ? 'ringStop' :
              '';

        return {
          ...state,
          ringAction,
        };
      }
      else if (messageType === MessageTypeConstants.MESSAGE_TYPE_AUTHORIZATION_REQUEST) {
        let newDataState = {
          ...state,
          deleteConfirmation: { ...message },
          authorizationRequest: { ...message },
        };
        return newDataState;
      }
      else if (messageType === MessageTypeConstants.MESSAGE_TYPE_CONTAINER) {
        return {
          ...state,
          showNotificationPopUp: true
        };
      }
      else if (messageType === MessageTypeConstants.MESSAGE_TYPE_HTML) {
        if (message?.options?.url) {
          return {
            ...state,
            urlContent: message.options.url,
            embedded: message.options.embedded
          };
        }
        else if (message?.options?.printScreen) {
          return {
            ...state,
            printScreen: message?.options?.printScreen,
          };
        } else
          return {
            ...state,
            showHTMLContent: message.options.content,
          }
      }
      else {

        let replaceIndex = shouldReplaceMessageByType(messages, message);
        if (replaceIndex !== -1) {
          let newMessage = JSON.parse(JSON.stringify(message));
          messages[replaceIndex] = newMessage;

          chatLog.set(conversationId, [...messages]);
          let newState = { ...state, chatLog, showWaitSpinner: false }; // messageType: "Runmode",
          // conversational: true
          if (state.contentMessage) {
            let cm = state.contentMessage;
            let rep = REPLACEMENT_ENABLED_FOR[newMessage.messageType];
            if (rep) {
              let matcher = rep.matcher;
              if (matcher && matcher(cm, newMessage)) {
                newState.contentMessage[conversationId] = newMessage;
              }
            }
          }
          return newState;
        }
        else if (messageType === MessageTypeConstants.MESSAGE_TYPE_FORM2) {
          let { options } = message;

          if (options.parent) {
            if (options.action === "results" || options.action === "validation") {
              let componentInWindow = cloneDeep(state.componentInWindow);

              if (!isEmpty(componentInWindow)) {
                const windowIndexToUpdate = getUpdateIndexFromComponentInWindowContainer(conversationId, componentInWindow, options);

                if (windowIndexToUpdate !== -1) {
                  const windowObjectToUpdate =
                    componentInWindow[conversationId][windowIndexToUpdate];

                  let containerMessages = windowObjectToUpdate.message;
                  let getFormIndex = getUpdateIndexFromContainer(
                    containerMessages,
                    options
                  );

                  if (options.controlId === options.parent) {
                    if (windowObjectToUpdate.options?.keys && windowObjectToUpdate.options?.keys.length) {
                      let keysArr = windowObjectToUpdate.options.keys;
                      let fieldId = message.message.field;
                      for (let i = 0; i < keysArr.length; i++) {
                        if (fieldId === keysArr[i].id) {
                          if (message.message.result) {
                            keysArr[i].results = message.message.result;
                          }
                          if (Object.prototype.hasOwnProperty.call(message.message, "validationResult")) {
                            keysArr[i].validationResult =
                              message.message.validationResult;
                          }
                          if (message.message.validationMessage) {
                            keysArr[i].validationMessage =
                              message.message.validationMessage;
                          }
                        }
                      }
                    }
                  } else {
                    if (getFormIndex !== -1) {
                      let formInContainer = containerMessages[getFormIndex];
                      let formInContainerMessage = formInContainer.message;

                      if (Object.prototype.hasOwnProperty.call(message.message, "field")) {
                        for (let i = 0; i < formInContainerMessage.fields.length; i++) {
                          let m = formInContainerMessage.fields[i];
                          if (m.id === message.message.field) {
                            if (message.message.results) {
                              m.showSpinner = false;
                              m.results = message.message.results;
                            }

                            if (Object.prototype.hasOwnProperty.call(message.message, "validationResult")) {
                              m.validationResult =
                                message.message.validationResult;
                            }
                            if (message.message.validationMessage) {
                              m.validationMessage =
                                message.message.validationMessage;
                            }
                          }
                        }
                      } else {
                        formInContainerMessage.genericError = {
                          ...message.message,
                        };
                      }

                      if (
                        conversationId &&
                        windowIndexToUpdate &&
                        getFormIndex &&
                        componentInWindow[conversationId] &&
                        componentInWindow[conversationId][
                        windowIndexToUpdate
                        ] &&
                        componentInWindow[conversationId][windowIndexToUpdate]
                          .messsage &&
                        componentInWindow[conversationId][windowIndexToUpdate]
                          .messsage[getFormIndex]
                      ) {
                        componentInWindow[conversationId][
                          windowIndexToUpdate
                        ].messsage[getFormIndex].message = {
                          ...formInContainerMessage,
                        };
                      }
                    }
                  }
                }
              }
              let updatedComponentInWindow = Object.assign({}, componentInWindow);
              let newState = {
                ...state,
                componentInWindow: updatedComponentInWindow,
                showWaitSpinner: false,
              };
              return newState;
            } else if (options.action === "change") {
              let componentInWindow = cloneDeep(state.componentInWindow);
              if (!isEmpty(componentInWindow)) {
                const windowIndexToUpdate = getUpdateIndexFromComponentInWindowContainer(conversationId, componentInWindow, options);

                if (windowIndexToUpdate !== -1) {
                  const windowObjectToUpdate = componentInWindow[conversationId][windowIndexToUpdate];

                  let containerMessages = windowObjectToUpdate.message;
                  let getFormIndex = getUpdateIndexFromContainer(containerMessages, options);
                  if (getFormIndex !== -1) {
                    let formInContainer = containerMessages[getFormIndex];
                    let formInContainerMessage = formInContainer.message;
                    let formFieldsCopy = formInContainerMessage.fields;

                    if (Object.prototype.hasOwnProperty.call(message.message, "remove")) {
                      let messageRemove = message.message.remove;

                      for (let elemRemove of messageRemove) {
                        let getIndexToRemove = formFieldsCopy.findIndex((elem) => elem.id === elemRemove);
                        if (getIndexToRemove > -1) {
                          formFieldsCopy.splice(getIndexToRemove, 1);
                        }
                      }
                    } else if (Object.prototype.hasOwnProperty.call(message.message, "fields")) {
                      let messageUpdateFields = message.message.fields;
                      if (!isEmpty(messageUpdateFields)) {
                        formFieldsCopy.forEach((field) => {
                          for (let updateField of messageUpdateFields) {
                            if (updateField.id === field.id) {
                              field.value = updateField.value;
                            }
                          }
                        });
                      }
                    }
                  }
                }
              }

              let updatedComponentInWindow = Object.assign({}, componentInWindow);
              let newState = {
                ...state,
                componentInWindow: updatedComponentInWindow,
                showWaitSpinner: false,
              };
              return newState;
            }
          } else {
            if (!isEmpty(conversationalMode) && !conversationalMode.conversational) {
              const componentInWindow = state.componentInWindow;
              if (!isEmpty(componentInWindow)) {
                const windowIndexToUpdate = getUpdateIndexFromComponentInWindow(conversationId, componentInWindow, options);

                if (windowIndexToUpdate === -1) {
                  componentInWindow[conversationId] = componentInWindow[conversationId] && componentInWindow[conversationId].length > 0
                    ? componentInWindow[conversationId]
                    : [];
                  componentInWindow[conversationId].push(message);
                } else {
                  if (message.options.action === "results" || message.options.action === "validation") {
                    const windowObjectToUpdate = componentInWindow[conversationId][windowIndexToUpdate];
                    const messages = windowObjectToUpdate.message;
                    if (Object.prototype.hasOwnProperty.call(message.message, "field")) {
                      if (Array.isArray(messages)) {
                        // For forms with fields list
                        for (let i = 0; i < messages.length; i++) {
                          let m = messages[i];
                          if (m.id === message.message.field) {
                            if (message.message.results) {
                              m.showSpinner = false;
                              m.results = message.message.results;
                            }
                            if (Object.prototype.hasOwnProperty.call(message.message, "validationResult")) {
                              m.validationResult = message.message.validationResult;
                            }
                            if (message.message.validationMessage) {
                              m.validationMessage = message.message.validationMessage;
                            }
                            break;
                          }
                        }
                      } else {
                        // For tables, validation messages are stored as state.chats.componentInWindow 
                        componentInWindow[conversationId].push(message);
                      }

                    } else {
                      windowObjectToUpdate.genericError = { ...message.message, };
                    }

                    componentInWindow[conversationId][windowIndexToUpdate] = windowObjectToUpdate;

                  } else if (message.options.action === "change") {
                    const windowObjectToUpdate =
                      componentInWindow[conversationId][windowIndexToUpdate];
                    let messages = windowObjectToUpdate.message;
                    const fieldsToUpdate = message.message.fields;
                    const fieldsToRemove = message.message.remove;

                    if (!isEmpty(fieldsToRemove)) {
                      windowObjectToUpdate.message = messages.filter(
                        (message) => {
                          let mId = message.id;
                          return fieldsToRemove.indexOf(mId) !== -1;
                        }
                      );
                    }

                    if (!isEmpty(fieldsToUpdate)) {
                      window.lastMsgFields = fieldsToUpdate;
                      windowObjectToUpdate.message =
                        Array.isArray(messages) &&
                        messages.map((message) => {
                          let mId = message.id;
                          for (let i = 0; i < fieldsToUpdate.length; i++) {
                            const incomingField = fieldsToUpdate[i];
                            if (incomingField.id === mId) {
                              return incomingField;
                            }
                          }
                          return message;
                        });
                    }

                    componentInWindow[conversationId][windowIndexToUpdate] =
                      windowObjectToUpdate;
                  }
                }
              } else {
                componentInWindow[conversationId] = [];
                componentInWindow[conversationId].push(message);
              }
              let updatedComponentInWindow = Object.assign({}, componentInWindow);

              let newStateData = {
                ...state, componentInWindow: updatedComponentInWindow, showWaitSpinner: false,
              };
              return newStateData;
            } else if (!isEmpty(conversationalMode) && conversationalMode.conversational) {
              if (
                options &&
                options.formId &&
                state.formInPopup &&
                state.formInPopup.options &&
                options.formId === state.formInPopup.options.formId
              ) {
                let newObj = {};
                if (
                  message.options.action === "results" ||
                  message.options.action === "validation"
                ) {
                  let currentMessage = state.formInPopup;
                  let cmm = currentMessage.message;
                  for (let i = 0; i < cmm.length; i++) {
                    let m = cmm[i];
                    if (m.id === message.message.field) {
                      if (message.message.results) {
                        m.showSpinner = false;
                        m.results = message.message.results;
                      }
                      if (Object.prototype.hasOwnProperty.call(message.message, "validationResult")) {
                        m.validationResult = message.message.validationResult;
                      }
                      if (message.message.validationMessage) {
                        m.validationMessage = message.message.validationMessage;
                      }
                      break;
                    }
                  }
                  newObj = Object.assign({}, { ...state.formInPopup });
                } else {
                  let newMessage = cloneDeep(message);
                  let formPopup = cloneDeep(state.formInPopup);

                  if (newMessage.message && newMessage.message.fields) {
                    newMessage.message.fields.forEach((elem) => {
                      let findIndex = formPopup.message.findIndex(
                        (elemForm) => elemForm.id === elem.id
                      );

                      if (findIndex !== -1) {
                        formPopup.message[findIndex] = elem;
                      }
                    });
                  } else {
                    newMessage.message.forEach((elem) => {
                      let findIndex = formPopup.message.findIndex(
                        (elemForm) => elemForm.id === elem.id
                      );

                      if (findIndex !== -1) {
                        formPopup.message[findIndex] = elem;
                      }
                    });
                  }

                  newObj = Object.assign({}, { ...formPopup });
                }
                return {
                  ...state,
                  formInPopup: newObj,
                  showWaitSpinner: false,
                };
              } else if (
                message.options.action === "results" ||
                message.options.action === "validation"
              ) {
                let newDataState = {
                  ...state,
                  formInPopup: { ...message },
                  showWaitSpinner: false,
                };
                return newDataState;
              }
            }
          }
        }

        // Handle FloorPlan Messages -- DEMO ONLY

        if (message.messageType === MessageTypeConstants.MESSAGE_TYPE_FLOORPLAN && message.contentType === 150) {
          let newState = { ...state, chatLog, showWaitSpinner: false }; // messageType: "Runmode",
          newState.contentMessage = message;
          return newState;
        }
        placeMessageBasedOnTime(messages, message);

        chatLog.set(conversationId, [].concat(messages));
        let newState = { ...state, chatLog: chatLog };
        const selectedConversation = newState?.selectedConversation;
        if (conversationId === selectedConversation) {
          newState = { ...state, chatLog: chatLog, showWaitSpinner: false };
        }

        newState.timeLine = updateConversationMetaData(timeLine, selectedConversation, conversationId, message);

        // MessageTypeConstants.MESSAGE_TYPE_STRING is handled below
        const { selectedBotDetails } = action.data;

        if (messageType === MessageTypeConstants.MESSAGE_TYPE_STRING && selectedBotDetails && !selectedBotDetails.conversational
          && !selectedBotDetails.systemBot && state?.chatwidgetNotifications) {
          newState = {
            ...newState,
            chatwidgetNotifications: [...state.chatwidgetNotifications, { ...message, show: true },],
          };
        }

        if (messageType === MessageTypeConstants.MESSAGE_TYPE_STD_NOTIFICATION) {
          const notificationsMsgArray = { ...state.notificationsMsgArray };
          const convArray = notificationsMsgArray[conversationId]
            ? [...notificationsMsgArray[conversationId]]
            : [];

          const filtered = convArray.filter(
            (item) => item?.messageId !== message?.messageId
          );
          filtered.push(message);

          notificationsMsgArray[conversationId] = filtered;

          newState = {
            ...newState,
            standardNotiMsg: message,
            notificationsMsgArray,
          };
        }

        return newState;
      }
    }

    case ARCHIVED_MESSAGES_RECEIVED: {
      const { conversationId, messages = [], moreMessagesExist, userId } = action.data;

      const { chatLog, conversationPaginationParameterMap } = state;

      // Existing messages for this conversation (if any)
      const existingMessages = chatLog.get(conversationId) || [];

      // Merge & de-duplicate based on whether we're appending to full history or not
      const allMessages = mergeAndSortMessages(messages, existingMessages);

      // Update the chatLog immutably (Map copy for Redux safety)
      const updatedChatLog = new Map(chatLog);
      updatedChatLog.set(conversationId, allMessages);

      // Update pagination parameters
      const updatedPagination = updatePagination(
        conversationPaginationParameterMap,
        conversationId,
        messages,
        moreMessagesExist
      );

      // Default return if no special case triggered
      return {
        ...state,
        chatLog: updatedChatLog,
        conversationPaginationParameterMap: updatedPagination,
      };
    }

    case HIDE_CHATWIDGET_NOTIFICATION:
      return {
        ...state,
        chatwidgetNotifications: state.chatwidgetNotifications.map((n) =>
          n.messageId === action.data.id ? { ...n, show: false } : n
        ),
      };


    case ADD_NEW_CONVERSATION: {
      let { timeLine, chatLog, contacts } = state;
      let { conversation, oneToOneChat } = action.data;

      let exConversation = getConversationById(state, conversation.conversationId);
      if (exConversation) {
        return state;
      }

      chatLog.set(conversation.conversationId, []);
      return {
        ...state,
        timeLine: [conversation].concat(timeLine),
        contacts,
        chatLog,
        selectedConversation: conversation,
        ...(oneToOneChat ? { oneToOneChat: true } : { oneToOneChat: false }),
      };
    }

    case CHANGE_SELECTED_CONVERSATION: {
      let { conversation, toTop, oneToOneChat } = action.data;
      let { timeLine, chatLog } = state;

      if (!conversation) {
        return {
          ...state,
          selectedConversation: {
            conversationId: "",
          },
          ...(oneToOneChat ? { oneToOneChat: true } : { oneToOneChat: false }),
        };
      }


      let index = timeLine.findIndex((con) => {
        return con.conversationId === conversation.conversationId;
      });

      let clonedConversation = { ...conversation, newMessagesCount: 0 };
      let partOfState = {};

      if (clonedConversation.bot && clonedConversation.bot.botId === IM_BOT && !clonedConversation.channel) {
        let chatMessages = chatLog.get(conversation.conversationId);
        let lastMessage =
          !isEmpty(chatMessages) && chatMessages[chatMessages.length - 1];
        if (
          (lastMessage &&
            state.userId !== lastMessage.createdBy &&
            lastMessage.messageType ===
            MessageTypeConstants.MESSAGE_TYPE_ACCEPT_IGNORE_CONTACT) ||
          (lastMessage &&
            lastMessage.contentType ===
            MessageTypeConstants.MESSAGE_TYPE_ACCEPT_IGNORE_CONTACT)
        ) {
          partOfState.acceptIgnoreContact = lastMessage;
        } else {
          partOfState.acceptIgnoreContact = null;
        }
      } else {
        partOfState.acceptIgnoreContact = null;
      }

      if (toTop) {
        // if (index !== -1) {
        //   timeLine.splice(index, 1);
        // }

        return {
          ...state,
          selectedConversation: clonedConversation,
          ...initialContentState,
          showWaitSpinner: false,
          searchBoxMessage: null,
          ...partOfState,
        };
      } else {
        if (index !== -1) {
          timeLine[index] = clonedConversation;
        }
      };

      return {
        ...state,
        selectedConversation: clonedConversation,
        ...initialContentState,
        showWaitSpinner: false,
        searchBoxMessage: null,
        ...partOfState,
      };
    }

    case TIME_LINE_RECEIVED: {
      let { timeLine,favorites } = state;
      timeLine = action.data.timeLine || [];
      favorites = action.data.favourites || [];
      let chatLog = state.chatLog;
      let oldTimeLine = cloneDeep(state.timeLine);
      let selectedConversation = action.data.selectedConversation;

      if (oldTimeLine && oldTimeLine.length) {
        timeLine = [...oldTimeLine, ...timeLine];
      }
      timeLine.forEach(function (conversation) {
        if (
          action.data.changeCurrent === false &&
          conversation.conversationId === selectedConversation.conversationId
        ) {
          console.log("Dont change the current");
        } else {
          chatLog.set(conversation.conversationId, []);
        }
      });

      if (selectedConversation && selectedConversation.conversationId) {
        let getTheIndexOnConversation = timeLine.findIndex(
          (elem) => elem.conversationId === selectedConversation.conversationId
        );

        if (getTheIndexOnConversation === -1) {
          if (
            selectedConversation.contact &&
            selectedConversation.contact.showAcceptIgnoreMsg
          ) {
            selectedConversation["message"] = {
              ...selectedConversation.contact,
            };
            selectedConversation["contentType"] =
              MessageTypeConstants.MESSAGE_TYPE_ACCEPT_IGNORE_CONTACT;
          }
          chatLog.set(
            selectedConversation.conversationId,
            [].concat([{ ...selectedConversation }])
          );
        }
      }

      return { ...state, timeLine: timeLine, userId: action.data.userId,favourites:favorites };
    }

    case GET_FAVOURITES: {

      let fav = [...action.data.getFavourites?.favourites];
      let peopleFav = [...action.data.getFavourites?.favouritePeople];
      let allFav = fav.concat(peopleFav);
      return { ...state, favourites: [...allFav] };
    }

    case TOGGLE__FAVORITE_CONVERSATION: {
      let timeLine = state.timeLine;
      let index = timeLine.findIndex(
        (t) => t.conversationId === action.data.conversationId
      );
      let conversation = timeLine[index];
      timeLine[index] = { ...conversation, favourite: action.data.favourite };
      sortByModifiedOn(timeLine);

      let stateData = { ...state, timeLine: [].concat(timeLine) };
      let selected = state.selectedConversation;
      if (selected.conversationId === conversation.conversationId) {
        stateData.selectedConversation = {
          ...conversation,
          favourite: action.data.favourite,
        };
      }
      return stateData;
    }

    case UPDATE_TIME_LINE: {
      return { ...state, timeLine: action.data.timeLine };
    }

    case CLEAR_TIME_LINE: {
      return { ...state, timeLine: [], chatLog: new Map() };
    }

    case SELECTED_CONTACT_DATA: {
      return { ...state, selectedContactData: action.payload };
    }

    case SELECTED_GROUP_CHAT: {
      return { ...state, selectedGroupChat: action.payload };
    }

    case SELECTED_GROUP_CHAT_PARTICIPANTS: {
      return { ...state, selectedGroupChatParticipants: action.payload };
    }

    case SET_ONE_TO_ONE_CHAT: {
      return { ...state, oneToOneChat: action.payload };
    }

    case SET_CHAT_IN_WINDOW: {
      return { ...state, chatInWindowOpen: action.payload.status, chatInWindowData: action.payload.message };
    }

    case SET_INITIALIZE_CHAT_IN_WINDOW: {
      return { ...state, initializechatInWindow: action.payload };
    }

    case SET_IMESSAGE_CHAT_ACTIVE_AREA_DEATAIL: {
      return { ...state, activeMessageChatAreaDetail: action.payload };
    }

    case SET_IMESSAGE_CHAT_ACTIVE_AREA: {
      return { ...state, activeMessageChatArea: action.payload };
    }

    case REMOVE_TABLE_MESSAGE:
      return { ...state, deleteConfirmation: null, authorizationRequest: null };

    case REMOVE_AUTHORIZATION_REQUEST:
      return { ...state, deleteConfirmation: null, authorizationRequest: null };

    case RESET_CHAT_REDUCER:
      return initialState;

    case STANDDARD_NOTI_MSG: 
      return { ...state, standardNotiMsg: action.payload };

    case SHOW_NOTIFICATION_POP_UP:
      return { ...state, showNotificationPopUp: action.payload };

    case UPDATE_CHATWIDGET_NOTIFICATIONS:
      return { ...state, chatwidgetNotifications: action.payload };

    case CLEAR_CHATWIDGET_NOTIFICATIONS:
      return { ...state, chatwidgetNotifications: [] };

    case CLEAR_URL_CONTENT:
      return { ...state, urlContent: null };
    case CLEAR_BOTCALL_CONTENT:
      return { ...state, botCallData: null };

    case CLEAR_SELECTED_CONVERSATION:
      return { ...state, selectedConversation: null };

    case CLEAR_PRINT_SCREEN_CHECK:
      return { ...state, printScreen: null };
    case REMOVE_NOTIFICATION:
    case RENDER_NOTIFICATION:
      return { ...state, notificationsMsgArray: action.data }
    default:
      return state;
  }
};


const getUpdateIndexFromComponentInWindow = (
  conversationId,
  componentInWindow,
  options
) => {
  const windowObject = componentInWindow[conversationId];
  if (!isEmpty(windowObject)) {
    for (let index = 0; index < windowObject.length; index++) {
      const message = windowObject[index];
      if (message.options && message?.options?.formId === options?.formId) {
        return index;
      }
    }
  }
  return -1;
};


const getUpdateIndexFromComponentInWindowContainer = (conversationId, componentInWindow, options) => {
  const windowObject = componentInWindow[conversationId];

  if (!isEmpty(windowObject)) {
    for (let index = 0; index < windowObject.length; index++) {
      const message = windowObject[index];
      if (message.options && message.options.controlId === options.parent) {
        return index;
      }
    }
  }
  return -1;
};


const getUpdateIndexFromContainer = (messageArray, options) => {
  if (!isEmpty(messageArray)) {
    for (let index = 0; index < messageArray.length; index++) {
      const message = messageArray[index].message;
      if (message.options && message.options.controlId === options.formId) {
        return index;
      }
    }
  }
  return -1;
};


export default chatsReducer;
